import { Injectable } from '@angular/core';
import { FileFolderNode } from '@r1-compass-library/components';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    getSidenavFolders(
        type: 'plays' | 'template-criteria' | 'lifecycle-rules' | 'dynamic-content'
    ): Observable<FileFolderNode[]> {
        switch (type) {
            case 'plays':
                return of<FileFolderNode[]>();
                break;
            case 'template-criteria':
                return of<FileFolderNode[]>();
                break;
            case 'lifecycle-rules':
                return of<FileFolderNode[]>();
                break;
            case 'dynamic-content':
                return of<FileFolderNode[]>();
                break;
            default:
                //error
                return of<FileFolderNode[]>();
        }
    }
}
